import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TrustedCybersecurityTechnologyConsultancyForTheUae from "./sections/TrustedCybersecurityTechnologyConsultancyForTheUae";
import ExperienceHighlights from "./sections/ExperienceHighlights";
import CoreExpertiseSolutions from "./sections/CoreExpertiseSolutions";
import TechnologyPartners from "./sections/TechnologyPartners";
import RequestAConsultation from "./sections/RequestAConsultation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />

      <TrustedCybersecurityTechnologyConsultancyForTheUae />

      <section id="certifications" className="bg-[#DCE5EC] px-6 py-12 md:px-10 md:py-14">
        <div className="mx-auto w-full max-w-7xl">
          <div className="mx-auto mb-8 max-w-3xl text-center">
            <span className="mb-2 block font-mono text-sm font-semibold uppercase tracking-widest text-[#13B8C8]">
              OUR CERTIFICATIONS
            </span>

            <h2 className="mb-3 text-4xl font-bold leading-tight tracking-tight text-[#0B1220] md:text-5xl">
              Certified, Trusted, Proven
            </h2>

            <p className="text-lg leading-relaxed text-slate-600">
              FETC maintains internationally recognized standards for
              information security, cloud security, and quality while supporting
              the UAE&apos;s In-Country Value objectives.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
            {/* ISO/IEC 27001:2022 */}
            <article className="flex h-full flex-col items-center rounded-2xl border border-slate-200 bg-white p-8 text-center">
              <div className="mb-6 flex h-32 w-full items-center justify-center">
                <img src="https://fetc.ae/wp-content/uploads/2026/07/ISO-2700191-1.png" alt="FETC ISO IEC 27001 2022 Certified Company" className="max-h-28 max-w-full object-contain" />
              </div>

              <h3 className="mb-3 text-2xl font-bold text-[#0B1220]">
                ISO/IEC 27001:2022
              </h3>

              <p className="mb-4 leading-relaxed text-slate-600">
                Information Security Management System
              </p>

              <span className="mt-auto text-sm font-semibold text-[#13B8C8]">
                Certified Management System
              </span>
            </article>

            {/* ISO/IEC 27017:2015 */}
            <article className="flex h-full flex-col items-center rounded-2xl border border-slate-200 bg-white p-8 text-center">
              <div className="mb-6 flex h-32 w-full items-center justify-center">
                <img src="https://fetc.ae/wp-content/uploads/2026/07/ISOIEC-27017-2015-Transparent-Logo.png" alt="FETC ISO IEC 27017 2015 Cloud Security Certified Company" className="max-h-28 max-w-full object-contain" />
              </div>

              <h3 className="mb-3 text-2xl font-bold text-[#0B1220]">
                ISO/IEC 27017:2015
              </h3>

              <p className="mb-4 leading-relaxed text-slate-600">
                Cloud Security Controls for Cloud Services
              </p>

              <span className="mt-auto text-sm font-semibold text-[#13B8C8]">
                Certified Cloud Security Controls
              </span>
            </article>

            {/* ISO 9001:2015 */}
            <article className="flex h-full flex-col items-center rounded-2xl border border-slate-200 bg-white p-8 text-center">
              <div className="mb-6 flex h-32 w-full items-center justify-center">
                <img src="https://fetc.ae/wp-content/uploads/2026/07/iso-9001-logo12-1-scaled.png" alt="FETC ISO 9001 2015 Certified Company" className="max-h-28 max-w-full object-contain" />
              </div>

              <h3 className="mb-3 text-2xl font-bold text-[#0B1220]">
                ISO 9001:2015
              </h3>

              <p className="mb-4 leading-relaxed text-slate-600">
                Quality Management System
              </p>

              <span className="mt-auto text-sm font-semibold text-[#13B8C8]">
                Certified Management System
              </span>
            </article>

            {/* UAE ICV */}
            <article className="flex h-full flex-col items-center rounded-2xl border border-slate-200 bg-white p-8 text-center">
              <div className="mb-6 flex h-32 w-full items-center justify-center">
                <img src="https://fetc.ae/wp-content/uploads/2026/07/fetc-icv-1.jpg" alt="FETC UAE In-Country Value Certified" className="max-h-28 max-w-full object-contain" />
              </div>

              <h3 className="mb-3 text-2xl font-bold text-[#0B1220]">
                UAE ICV Certified
              </h3>

              <p className="mb-4 leading-relaxed text-slate-600">
                UAE In-Country Value Program
              </p>

              <span className="mt-auto text-sm font-semibold text-[#13B8C8]">
                Certified UAE Service Provider
              </span>
            </article>
          </div>
        </div>
      </section>

      <ExperienceHighlights />

      <CoreExpertiseSolutions />

      <TechnologyPartners />

      <RequestAConsultation />

      <Footer />
    </div>;
}